const DATE_DDMMYY_REGEX = /^(\d{2})\/(\d{2})\/(\d{2,4})$/;

export function parseCustomDate(value) {
  if (typeof value !== 'string') {
    return Number.NaN;
  }

  const match = value.match(DATE_DDMMYY_REGEX);
  if (match) {
    const day = Number.parseInt(match[1], 10);
    const month = Number.parseInt(match[2], 10) - 1;
    let year = Number.parseInt(match[3], 10);
    if (year < 100) {
      year += 2000;
    }
    return new Date(year, month, day).getTime();
  }

  const date = Date.parse(value);
  return Number.isNaN(date) ? Number.NaN : date;
}
